// RecurringTaskResetService.js
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { COLLECTIONS } from '../hooks/useFirebase';

class RecurringTaskResetService {
  constructor(updateTask, userId) {
    this.updateTask = updateTask;
    this.userId = userId;
    this.db = getFirestore();
  }

  formatDateKey(date) {
    return date.toISOString().split('T')[0];
  }

  async getLastResetDate() {
    try {
      const resetRef = doc(this.db, 'users', this.userId, 'taskResets', 'recurring');
      const resetDoc = await getDoc(resetRef);
      return resetDoc.exists() ? resetDoc.data().lastResetDate : null;
    } catch (error) {
      console.error('Error getting last reset date:', error);
      return null;
    }
  }

  async updateLastResetDate(date) {
    try {
      const resetRef = doc(this.db, 'users', this.userId, 'taskResets', 'recurring');
      await setDoc(resetRef, { lastResetDate: date });
    } catch (error) {
      console.error('Error updating last reset date:', error);
    }
  }

  async checkAndResetTasks(tasks) {
    const now = new Date();
    const today = this.formatDateKey(now);
    const lastResetDate = await this.getLastResetDate();

    // If we've already reset today, don't reset again
    if (lastResetDate === today) {
      return;
    }

    // Process each task
    for (const task of tasks) {
      try {
        const content = JSON.parse(task.content || '[]');
        // Keep the task text but reset all checked states to false
        const resetContent = content.map(item => ({
          ...item,
          checked: false
        }));

        await this.updateTask(
          task.id,
          {
            content: JSON.stringify(resetContent),
            subtasks: resetContent
          },
          COLLECTIONS.RECURRING
        );
      } catch (error) {
        console.error(`Error resetting task ${task.id}:`, error);
      }
    }

    // Update the last reset date after all tasks have been processed
    await this.updateLastResetDate(today);
  }

  async clearData() {
    if (!this.userId) return;
    try {
      const resetRef = doc(this.db, 'users', this.userId, 'taskResets', 'recurring');
      await setDoc(resetRef, { lastResetDate: null });
    } catch (error) {
      console.error('Error clearing reset data:', error);
    }
  }
}

export { RecurringTaskResetService };